import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import {
    SettingsModule as SharedSettingsModule,
    ArmyBuilderSharedModule,
    SettingsSyncService,
    HttpClientWithInFlightCacheModule,
    SettingsService,
    PageLayoutModule,
    getTranslateModuleConfig
} from 'army-builder-shared';
import { NgLetModule } from 'ng-let';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SubscriptionModule } from '../subscription/subscription.module';

import { UserPage } from './user/user.page';
import { SettingsPage } from './settings.page';
import { SETTINGS_ROUTES } from './settings.routes';
import { FWWSettingsService } from './settings.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [SettingsPage, UserPage],
    imports: [
        CommonModule,
        IonicModule,
        PageLayoutModule,
        RouterModule.forChild(SETTINGS_ROUTES),
        SharedSettingsModule,
        ArmyBuilderSharedModule,
        NgLetModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientWithInFlightCacheModule,
        SubscriptionModule,
        TranslateModule.forChild(getTranslateModuleConfig('global'))
    ],
    providers: [InAppBrowser, { provide: SettingsService, useClass: FWWSettingsService }, FWWSettingsService]
})
export class FalloutSettingsModule {
    constructor(_settingsSyncService: SettingsSyncService) {}
}
